const errorKeys = {
  passwordMinimumLength: "passwordMinimumLength",
  minimumOneWppercaseLetter: "minimumOneWppercaseLetter",
  minimumOneLowercaseLetter: "minimumOneLowercaseLetter",
  minimumOneNumericDigit: "minimumOneNumericDigit",
  minimumOneSpecialCharacter: "minimumOneSpecialCharacter"
}

const environments = {
  devqa: "proxy-qa",
  staging_and_production: "proxy"
  };
const env = window.location.href.indexOf("dev") !== -1 ? environments.devqa : environments.staging_and_production;

const endpointValidatePhoneNumber = `/apps/${env}/validate-phone`;

let language = document.documentElement.getAttribute("lang");
if(language == "en-CA") language = "en";
if(language == "fr-CA") language = "fr";

/*
  Function to check if a password meets certain criteria.
  return: errors array
*/
function passwordValidation(
  field
) {
  const texts = window['validationErrors'];
  // Array to store error messages
  const errors = [];
  const password = field.value;
  const errorInputClassName = "input--error";
  const errorWrapperInputClassName = "input-wrapper--error";
  

  // Check if password is at least 8 characters long
  if (password.length < 8) {
    errors.push(texts[errorKeys.passwordMinimumLength]);
  }

  // Check if password contains at least one uppercase letter
  if (!/[A-Z]/.test(password)) {
    errors.push(texts[errorKeys.minimumOneWppercaseLetter]);
  }

  // Check if password contains at least one lowercase letter
  if (!/[a-z]/.test(password)) {
    errors.push(texts[errorKeys.minimumOneLowercaseLetter]);
  }

  // Check if password contains at least one numeric digit
  if (!/\d/.test(password)) {
    errors.push(texts[errorKeys.minimumOneNumericDigit]);
  }

  // Check if password contains at least one special character
  if (!/[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(password)) {
    errors.push(texts[errorKeys.minimumOneSpecialCharacter]);
  }

  const isValid = errors.length === 0;

  if(!isValid){
    field.classList.add(errorInputClassName);
    field.parentNode.classList.add(errorWrapperInputClassName);
  }else{
    field.classList.remove(errorInputClassName);
    field.parentNode.classList.remove(errorWrapperInputClassName);
  }

  // Return the array of error messages
  return errors;
}

function removeDuplicates(arr1, arr2) {
  // Combine the arrays
  const combinedArray = arr1.concat(arr2);

  // Use a Set to remove duplicates
  const uniqueArray = [...new Set(combinedArray)];

  return uniqueArray;
}


function backToCollection(collectionUrl = "/") {
  // Get the URL of the previous page
  const previousPageUrl = document.referrer;

  // Check if the previous page URL contains the word "collection"
  if (previousPageUrl.includes("collections")) {
    // If it does, go back to the previous page
    window.history.back();
  } else {
    // go to the collection page
    document.location.href = collectionUrl;
  }
}

/* Logic for forms validation */
const errorInputClassName = "input--error";
const errorWrapperInputClassName = "input-wrapper--error";

const doValuesMatch = (field1, field2, nesting = 1) => {
  const doesMatch = field1.value != field2.value || field1.value.trim() === "";

  if(doesMatch){
    field1.classList.add(errorInputClassName);
    field2.classList.add(errorInputClassName);
    field1.parentNode.classList.add(errorWrapperInputClassName);
    field2.parentNode.classList.add(errorWrapperInputClassName);
  }else{
    field1.classList.remove(errorInputClassName);
    field2.classList.remove(errorInputClassName);
    field1.parentNode.classList.remove(errorWrapperInputClassName);
    field2.parentNode.classList.remove(errorWrapperInputClassName);
  }

  const parent1 = nesting == 2 ? field1.parentNode.parentNode : field1.parentNode;
  const parent2 = nesting == 2 ? field2.parentNode.parentNode : field2.parentNode;
  const validationErrorContainer1 = parent1.querySelector(".input-validation-error");
  const validationErrorContainer2 = parent2.querySelector(".input-validation-error");
  const texts = window['validationErrors'];

  if(validationErrorContainer1) validationErrorContainer1.innerHTML = doesMatch ? texts['doesntMatch'] : "";
  if(validationErrorContainer2) validationErrorContainer2.innerHTML = doesMatch ? texts['doesntMatch'] : "";
  
  return field1.value == field2.value;
}

const isValidPhone = async (field) => {
  const cleaned = field.value.replace(/\D+/g, '');

  const response = await fetch(
    endpointValidatePhoneNumber + '?phone=' + encodeURIComponent(cleaned),
    {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    }
  );

  let json = {};

  try {
    json = await response.json();
  } catch (e) {
    console.error("Invalid JSON returned", e);
    return false;
  }

  const isValid = json.status === true;

  if (!isValid) {
    field.classList.add(errorInputClassName);
    field.parentNode.classList.add(errorWrapperInputClassName);
  } else {
    field.classList.remove(errorInputClassName);
    field.parentNode.classList.remove(errorWrapperInputClassName);
  }

  const validationErrorContainer = field.parentNode.querySelector(".input-validation-error");
  const texts = window['validationErrors'];

  if (validationErrorContainer)
    validationErrorContainer.innerHTML = !isValid ? texts["invalidPhone"] : "";

  return isValid;
}

const isValidEmail = (field) => {
  const emailRegex = new RegExp(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
  const isValid = emailRegex.test(field.value);

  if(!isValid){
    field.classList.add(errorInputClassName);
    field.parentNode.classList.add(errorWrapperInputClassName);
  }else{
    field.classList.remove(errorInputClassName);
    field.parentNode.classList.remove(errorWrapperInputClassName);
  }

  const validationErrorContainer = field.parentNode.querySelector(".input-validation-error");
  const texts = window['validationErrors'];

  if(validationErrorContainer) validationErrorContainer.innerHTML = !isValid ? texts['invalidEmail'] : "";

  return isValid;
}

/*
The format of zip code is as follows:
A1A1A1, where A is a letter and 1 is a digit
Validation rules are also:
Letters in zip code do not include the letters D, F, I, O, Q or U.
The first position also does not make use of the letters W or Z.
Accepter formats in the front-end:
A1A1A1, A1A 1A1. a1a1a1, a1a 1a1 (mixed upper case/lower case is accepted as well)
*/
const isValidPostalCode = (field) => {
  const postalCodeRegex = new RegExp(/^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVXYWZ][ ]?[0-9][ABCEGHJKLMNPRSTVXYWZ][0-9]$/i);
  const isValid = postalCodeRegex.test(field.value);

  if(!isValid){
    field.classList.add(errorInputClassName);
    field.parentNode.classList.add(errorWrapperInputClassName);
  }else{
    field.classList.remove(errorInputClassName);
    field.parentNode.classList.remove(errorWrapperInputClassName);
  }
  
  const validationErrorContainer = field.parentNode.querySelector(".input-validation-error");
  const texts = window['validationErrors'];

  if(validationErrorContainer) validationErrorContainer.innerHTML = !isValid ? texts['invalidPostalCode'] : "";

  return isValid;
}

/* Required field check */
const notEmptyField = (field, nesting, errorKey, errorMessage) => {
  const isEmpty = field.value.trim() == "";

  if(isEmpty){
    field.classList.add(errorInputClassName);
    field.parentNode.classList.add(errorWrapperInputClassName);
  }else{
    field.classList.remove(errorInputClassName);
    field.parentNode.classList.remove(errorWrapperInputClassName);
  }

  const parent = nesting == 2 ? field.parentNode.parentNode : field.parentNode;

  const validationErrorContainer = parent.querySelector(".input-validation-error");
  const texts = window['validationErrors'];

  if(validationErrorContainer) validationErrorContainer.innerHTML = isEmpty ? texts[errorKey] ? texts[errorKey] : errorMessage ? errorMessage : texts['thisFieldIsRequired'] : "";
  return !isEmpty;
}

/* Check length */
const checkFieldLength = ({
  field,
  nesting = 1,
  errorKey,
  length = 8
}) => {
  const isValid = field.value.trim().length >= length;

  if(!isValid){
    field.classList.add(errorInputClassName);
    field.parentNode.classList.add(errorWrapperInputClassName);
  }else{
    field.classList.remove(errorInputClassName);
    field.parentNode.classList.remove(errorWrapperInputClassName);
  }

  const parent = nesting == 2 ? field.parentNode.parentNode : field.parentNode;

  const validationErrorContainer = parent.querySelector(".input-validation-error");
  const texts = window['validationErrors'];
  const validationText = texts[errorKey ?? 'minimumLength'].replace(/8/g, length);

  if(validationErrorContainer) validationErrorContainer.innerHTML = !isValid ? validationText : "";

  return isValid;
}

/* Required input check (INPUT CHECKBOX) */
const checkedBox = (input, nesting, errorKey) => {
  const isChecked = input.checked;

  if(!isChecked){
    input.classList.add(errorInputClassName);
    input.parentNode.classList.add(errorWrapperInputClassName);
  }else{
    input.classList.remove(errorInputClassName);
    input.parentNode.classList.remove(errorWrapperInputClassName);
  }

  const parent = nesting == 2 ? input.parentNode.parentNode : input.parentNode;

  const validationErrorContainer = parent.querySelector(".input-validation-error");
  const texts = window['validationErrors'];

  if(validationErrorContainer) validationErrorContainer.innerHTML = !isChecked ? texts[errorKey ?? 'thisFieldIsRequired'] : "";

  return isChecked;
}

const isValidDob = (field) => {
  let isValid = false;
  const inputDate = new Date(field.value);
  const now = new Date(); 

  if (inputDate <= now) {
    isValid = true;
  } 
  if(!isValid){
    field.classList.add(errorInputClassName);
    field.parentNode.classList.add(errorWrapperInputClassName);
  }else{
    field.classList.remove(errorInputClassName);
    field.parentNode.classList.remove(errorWrapperInputClassName);
  }
  
  const validationErrorContainer = field.parentNode.querySelector(".input-validation-error");
  const texts = window['validationErrors'];

  if(validationErrorContainer) validationErrorContainer.innerHTML = !isValid ? texts['invalidDob'] : "";

  return isValid;
}

